
/**
 * Classe para almacenar los parámetros de configuración de SBSuite.
 *
 * @export
 * @class Params
 */
export class Params{
    
    /**
     *
     *
     * @private
     * @type {*}
     * @memberof Params
     */
    private _params: any = {};

    /**
     * Crea una instancia de Params.
     * 
     * @param {*} params
     * @memberof Params
     */
    constructor(params: any = []){
        if(!params) return;

        params.forEach(param=>{
            if(typeof param.nombre != 'undefined' && typeof param.valor != 'undefined') this._params[param.nombre] = param.valor;
        });
    }

    
    /**
     * Devuelve el valor de un parámetro.
     *
     * @param {string} [param=''] El nombre del parámetro.
     * @returns {*}
     * @memberof Params
     */
    getParam(param: string = ''): any{
        if(!param) return null;
        if(typeof this._params[param] == 'undefined') return null;
        return this._params[param];
    }

    /**
     * Establece el parámetro de logo.
     *
     * @param {string} [logo='']
     * @memberof Params
     */
    setLogo(logo: string = ''){
        this._params['LOGO_PATH'] = logo;
    }

    /**
     * Devuelve los parámetros de SBSuite.
     *
     * @returns {*}
     * @memberof Params
     */
    getParams(): any{
        return this._params;
    }

    /**
     * Devuelve true si el parámetro ASKFORQUANTITY está habilitado.
     *
     * @returns
     * @memberof Params
     */
    isAFQ(){
        let afq = this.getParam('ASKFORQUANTITY');
        return afq?true:false;
    }

    /**
     * Devuelve el valor del parámetro LOGO_PATH.
     *
     * @returns {string} El path del logo
     * @memberof Params
     */
    getSysLogo(): string{
        let logo = this.getParam('LOGO_PATH');
        return logo;
    }

}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/params.model.ts